import Referrals from '@/api/referrals'
import Jobs from '@/api/jobs'

export default {
  namespaced: true,
  state: {
    referrals: [],
    currentJobReferrals: [],
    currentJob: '',
    refGeneralLink: '',
    refLink: '',
    stats: null,
    hired: []
  },
  getters: {
    referralStatus: state => referral => {
      if (referral.status === 'unconsumed') {
        return 'pending'
      } else if (referral.applicationStatus === 'hired') {
        return 'hired'
      } else if (referral.applicationStatus === null) {
        return 'pending'
      } else if (referral.applicationStatus) {
        return 'applied'
      } else {
        return 'rejected'
      }
    },
    stats: state => {
      return state.stats
    }
  },
  mutations: {
    setReferrals (state, referrals) {
      state.referrals = referrals
    },
    setCurrentJobReferrals (state, currentJobReferrals) {
      state.currentJobReferrals = currentJobReferrals
    },
    setCurrentJob (state, currentJob) {
      state.currentJob = currentJob
    },
    setReferralGeneralLink (state, link) {
      state.refGeneralLink = link
    },
    setReferralLink (state, link) {
      state.refLink = link
    },
    setStats (state, stats) {
      state.stats = stats
    },
    setHired (state, hired) {
      state.hired = hired
    }
  },
  actions: {
    async getReferrals ({ commit }) {
      const referrals = await Referrals.get()
      commit('setReferrals', referrals)
    },
    async getJobReferrals ({ commit }, jobId) {
      const job = await Jobs.get(jobId)
      commit('setCurrentJob', job)
      const referrals = await Referrals.getForJob(jobId)
      commit('setCurrentJobReferrals', referrals)
    },
    async getGeneralLink ({ commit }, data) {
      const result = await Referrals.getLink(data.jobId)
      commit('setReferralGeneralLink', result.link)
    },
    async getLink ({ commit }, data) {
      const result = await Referrals.getLink(data.jobId)
      const url = data.urlPrefix + result.link
      commit('setReferralLink', url)
    },
    async getStats ({ commit }) {
      const result = await Referrals.getStats()
      commit('setStats', result)
    },
    async getHired ({ commit }) {
      const result = await Referrals.getHired()
      commit('setHired', result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/referrals.js